<div class="lum-c-cost-layer-info">
  <ng-container
    *ngIf="store.viewingCostLayer$ | async as costLayer; else whenNoData"
  >
    <div class="lum-c-cost-layer-info__basic">
      <div class="grow">
        <dl class="dl-grid dl-grid--inline gap-x-2">
          <dt class="h5 mb-1">SKU</dt>
          <dd class="h5 mb-1"
            ><a
              [routerLink]="['/inventory', costLayer.productId, 'view']"
              [queryParams]="{ v: 'costs' }"
              >{{ costLayer.product?.internalSku }}</a
            ></dd
          >

          <dt>At Warehouse</dt>
          <dd>{{ costLayer.warehouse?.locationName }}</dd>

          <dt>PO</dt>
          <dd>
            <a
              *ngIf="costLayer.purchaseOrder?.id; else whenNoPO"
              [routerLink]="['/orders', costLayer.purchaseOrder.id]"
            >
              #{{ costLayer.purchaseOrder?.id }}
            </a>
            <ng-template #whenNoPO>-</ng-template>
          </dd>

          <dt>Shipment</dt>
          <dd>
            <a
              *ngIf="costLayer.shipment?.id; else whenNoShipment"
              [routerLink]="['/orders/shipments', costLayer.shipment.id]"
            >
              #{{ costLayer.shipment?.id }}
            </a>
            <ng-template #whenNoShipment>-</ng-template>
          </dd>

          <dt>Receipt</dt>
          <dd>
            <button
              *ngIf="costLayer.receipt?.id; else whenNoReceipt"
              type="button"
              class="linkish"
              (click)="handleReceiptClick($event, costLayer.receipt?.id)"
            >
              #{{ costLayer.receipt?.id }}
            </button>
            <ng-template #whenNoReceipt>-</ng-template>
          </dd>
          <dt>Notes</dt>
          <dd>{{ costLayer.description ?? '-' }}</dd>
        </dl>
      </div>

      <div class="grow">
        <dl class="dl-grid dl-grid--inline gap-x-2">
          <dt>Total Cost</dt>
          <dd class="text-right">{{ costLayer.totalCost | currency }}</dd>

          <dt>Unit Cost</dt>
          <dd class="text-right">{{ costLayer.costPerUnit | currency }}</dd>

          <dt>Initial Qty</dt>
          <dd class="text-right">
            {{ costLayer.initialQuantity | decimalPlaces }}
          </dd>

          <dt>Remaining Qty</dt>
          <dd class="text-right">
            {{ costLayer.remainingQuantity | decimalPlaces }}
          </dd>
        </dl>
      </div>
    </div>

    <!-- <section class="mt-5">
      <h5>Cost Calculation Details</h5>
      <p class="text-muted">@TODO</p>
    </section> -->

    <section class="mt-5">
      <h5>History</h5>

      <nav mat-tab-nav-bar [tabPanel]="historyTabContent">
        <a
          mat-tab-link
          [active]="currentChangesSubset === ECostLayerChangesSubset.QUANTITY"
          [queryParams]="_ChangesParamsBySubset[ECostLayerChangesSubset.QUANTITY]"
          queryParamsHandling="merge"
          [routerLink]="[]"
          >Quantity Changes</a
        >
        <a
          mat-tab-link
          [active]="currentChangesSubset === ECostLayerChangesSubset.ALL"
          [queryParams]="_ChangesParamsBySubset[ECostLayerChangesSubset.ALL]"
          queryParamsHandling="merge"
          [routerLink]="[]"
          >All History</a
        >
      </nav>

      <mat-tab-nav-panel #historyTabContent>
        <div class="my-4">
          <lum-cost-layer-changes-dumb-log
            [agGridOptions]="agGridOptions"
            [columnsPreset]="currentChangesLayout"
            paging="serverSide"
            (gridReady)="handleGridReady($event)"
            (paginationChanged)="handlePaginationChanged()"
          ></lum-cost-layer-changes-dumb-log>
        </div>
      </mat-tab-nav-panel>
    </section>
  </ng-container>
  <ng-template #whenNoData>
    <ng-container *ngIf="store.viewingCostLayerLoading$ | async; else whenFailed"
      >...</ng-container
    >
    <ng-template #whenFailed>
      Oops! We couldn't load the data for this cost layer.
    </ng-template>
  </ng-template>
</div>
